/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientIcon.vue?vue&type=template&id=50bb4478"
import script from "./PatientIcon.vue?vue&type=script&lang=js"
export * from "./PatientIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bb4478')) {
      api.createRecord('50bb4478', component.options)
    } else {
      api.reload('50bb4478', component.options)
    }
    module.hot.accept("./PatientIcon.vue?vue&type=template&id=50bb4478", function () {
      api.rerender('50bb4478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/PatientIcon.vue"
export default component.exports